
import Vue from 'vue';
import * as _ from 'lodash';
import { mapState, mapActions } from 'vuex';
import { generateOrder, IOrder } from '~/models/orders';
import VInput from '~/components/Form/VInput.vue';
import VCurrency from '~/components/Form/VCurrency.vue';
import VPercentage from '~/components/Form/VPercentage.vue';
import { DepositType } from '~/pages/dashboard/settings-models/types';

export default Vue.extend({
  name: 'CreateBoost',
  components: { VInput, VCurrency, VPercentage },
  data() {
    return {
      order: {} as IOrder,
      required: false,
      isLoading: false,
      errorMessage: '',
    };
  },
  computed: {
    ...mapState('auth', {
      user: (state: any) => state.user,
      merchant: (state: any) => state.merchant,
      activeMerchantId: (state: any) => state.activeMerchantId,
      voucherSettings: (state: any) => {
        return {
          minimum: state.merchant.voucherSettings.minimumSavingGoalInCents,
          maximum: state.merchant.voucherSettings.maximumSavingGoalInCents,
          rewardType: state.merchant.voucherSettings.rewardType,
          rewardFlatAmountInCents: state.merchant.voucherSettings.rewardFlatAmountInCents,
          rewardPercentage: state.merchant.voucherSettings.rewardPercentage,
          voucherProviders: state.merchant.voucherSettings.voucherProviders[0].name,
        };
      },
    }),
  },
  created() {
    this.constructOrder();
  },
  methods: {
    ...mapActions({
      createOrder: 'orders/createOrder',
    }),
    async submit() {
      try {
        this.errorMessage = '';
        this.isLoading = true;
        this.order.type = 'REWARDS';
        const createdOrder = await this.createOrder(this.order);
        this.$emit('next:share-link', createdOrder);
      } catch (e: any) {
        this.errorMessage = 'Something went wrong. Please try again!';
        if (e.response.data) {
          this.errorMessage = e.response.data;
        }
      } finally {
        this.isLoading = false;
      }
    },
    isEmpty(value) {
      return _.isEmpty(value);
    },
    constructOrder() {
      this.order = generateOrder();
      this.order.name = 'Voucher SKU';
      // Adding the minimumSavingGoalInCents amount as the order amount, user will be able update this amount
      this.order.amountDue = this.merchant.voucherSettings.minimumSavingGoalInCents;

      if (this.merchant.paymentPlans.defaultDepositType.enabled) {
        if (this.merchant.paymentPlans.defaultDepositType.depositType === DepositType.Instalment) {
          this.order.depositType = DepositType.Instalment;
        }
        if (this.merchant.paymentPlans.defaultDepositType.depositType === DepositType.Percentage) {
          this.order.depositType = DepositType.Percentage;
          this.order.depositPerc = this.merchant.paymentPlans.defaultDepositType.percentage;
        }

        if (this.merchant.paymentPlans.defaultDepositType.depositType === DepositType.Flat) {
          this.order.depositType = DepositType.Flat;
          this.order.depositAmount = this.merchant.paymentPlans.defaultDepositType.flat;
        }
      }
    },
  },
});
